<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">「交大之星」计划</span></p>'
      + '<p style="margin-bottom : 20px; margin-top : 40px"><span style="margin-left: 36px; font-size: 16px;">依托“大设施”（转化医学国家重大科技基础设施），围绕“大目标”（生命、健康、创新、合作）， 布局“大计划”（自主性、前瞻性医理工交叉研究计划），统筹资源，升级建立“交大之星”（STAR） 计划，用于资助科学技术人员和临床研究人员开展以临床问题和临床需求为导向的前沿探索，支持人才和团队建设，以激励原始创新，切实提高科研原创能力，推动交叉研究的发展。</span></p>'

      +'<p style="margin-left : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star1.png" style="width: 850px; margin-right: 16px;margin-bottom: 0px;" width="960px"  border="0" vspace="0" alt=""></p>'
      +'<p style="margin-bottom : 0px; margin-left: 30px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star2.png" style="width: 820px; margin-bottom: 0px;" border="0" vspace="0" alt=""></p>'

      + '<div style="width: 100%">'
      + '<div id="right" style="float:left ; margin-top: 40px; width:50%; height:100%;">'
      + '<ul>' +
      '<li style="margin-left: 30px; font-size: 18px; font-weight: bold">青年项目</li>' +
      '<li style="margin-left: 30px; margin-bottom : 20px;font-size: 16px;">用于支持医学院及其附属医院 40 岁以下青年科技人员，开展自主合作型原创性交叉科研。</li>' +
      '<li style="margin-left: 30px; font-size: 18px; font-weight: bold">重点项目</li>' +
      '<li style="margin-left: 30px; margin-bottom : 20px;font-size: 16px;">以临床问题为导向，支持领域内专家开展自主交叉研究，布局国家重大重点项目预研。</li>' +
      '<li style="margin-left: 30px; font-size: 18px; font-weight: bold">重大项目</li>' +
      '<li style="margin-left: 30px; margin-bottom : 20px;font-size: 16px;">关注科研方向建设，以重大临床需求＋关键核心技术为导向，通过“基础－临床－技术” 交叉融合，形成一批关键技术临床应用的新方向。</li>' +
      '</ul>'
      + '</div>'
      + '<div id="left" style="float:left ;margin-left : 80px; margin-top: 30px;  width:40%; height:100%;">'
      + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/start3.jpg" style="height:303px;" alt="">'
      + '</div>'
      + '</div>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'

    //+'<p style="margin-bottom : 0px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star3.png" style="width: 960px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event1/index.vue